export const canUserViewPrivateComments = (user): boolean =>
  user.role !== 'collaborator' && user.role !== 'guest';
